<script lang="ts">
  import { browser } from '$app/environment';

  import { onMount, onDestroy } from 'svelte';
  let ref: HTMLDivElement;
  let portal: HTMLDivElement;

  onMount(() => {
    if (browser) {
      portal = document.createElement('div');
      portal.className = 'portal';
      document.body.appendChild(portal);
      portal.appendChild(ref);
    }
  });

  onDestroy(() => {
    if (browser && portal && portal.parentNode) {
      document.body.removeChild(portal);
    }
  });
</script>

<div class="invisible hidden">
  <div bind:this="{ref}">
    <slot />
  </div>
</div>
